// 管理 商品一覧

import Frame from "components/WonderOrder/Frame/ManagementFrame";

/* eslint-disable no-magic-numbers */
const data = [
  // {
  //   id:       "1",
  //   name:     "生ビール（中）",
  //   category: "1",
  //   prices:   [
  //     { tax: 10, price: 480 },
  //     { tax: 10, price: 480 }
  //   ]
  // },
  {
    location:  "03",
    number:    3,
    visitTime: "11:30",
    status:    "会計前",
    amount:    "2,000",
    items:     [
      { name: "生ビール（中）", amount: 480, number: 1 },
      { name: "ゆずサワー", amount: 780, number: 2 },
      { name: "鉄板牛ステーキ", amount: 800, number: 1 },
      { name: "肉じゃがコロッケ", amount: 280, number: 1 }
    ]
  },
  {
    location:  "06",
    number:    1,
    visitTime: "11:35",
    status:    "会計中",
    amount:    "2,000",
    items:     [
      { name: "生ビール（中）", amount: 480, number: 1 },
      { name: "刺身盛り合わせ", amount: 1600, number: 2 }
    ]
  }
];
/* eslint-enable no-magic-numbers */

const Page = function () {
  return (
    <Frame title="契約者基本情報" menuCode="company">
      <>
        <div className="container-fluid">
          <div className="row border-bottom">
            <div className="col-12 pb-2">
              <h2 className="fs-5 fw-bold border-bottom border-2 border-primary">基本情報</h2>
              <div className="color-bg-primary color-text-clear clearfix my-3 px-2 py-2">
                <div
                  className="float-start"
                  style={{ fontWeight: "bold", lineHeight: 2 }}
                >
                来店一覧
                </div>
                <div className="float-end btn-toolbar p-1">
                  <button
                    className="btn btn-sm color-bg-clear color-text-primary color-border-clear"
                    style={{ borderRadius: "2em" }}
                  >
                  新規来店
                  </button>
                  <button
                    className="btn btn-sm color-bg-clear color-text-alert color-border-clear ms-2"
                    style={{ borderRadius: "2em" }}
                  >
                  来店取消
                  </button>
                </div>
              </div>
              <div className="px-1">
                <div className="card border-0">
                  <div className="card-body p-1">
                    <div className="row small">
                      <div className="col-4">テーブル</div>
                      <div className="col-2">人数</div>
                      <div className="col-2">来店時刻</div>
                      <div className="col-2">ステータス</div>
                      <div className="col-2">金額</div>
                    </div>
                  </div>
                </div>
                {data.map((d, i) => (
                  <div
                    key={`customer-${i}`}
                    className="card mb-1"
                  >
                    <div className="card-body p-1">
                      <div className="row">
                        <div className="col-4">{d.location}</div>
                        <div className="col-2">{d.number}名</div>
                        <div className="col-2">{d.visitTime}〜</div>
                        <div className="col-2">{d.status}</div>
                        <div className="col-2">&yen;{d.amount}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    </Frame>
  );
};

export default Page;
